
import SuperAdminPanel from "../components/superadmin/SuperAdminDashboard";

export default function AdminDashboard() {
  return (
    <div>
      <SuperAdminPanel />
    </div>
  );
}
